import createIcon from '../../createIcon';

/**
 * @component @name LockPerson
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNSAxMUMxNy4yIDExIDE3Ljg3IDExLjEgMTguNSAxMS4yOVYxMEMxOC41IDguOSAxNy42IDggMTYuNSA4SDE1LjVWNkMxNS41IDMuMjQgMTMuMjYgMSAxMC41IDFDNy43NCAxIDUuNSAzLjI0IDUuNSA2VjhINC41QzMuNCA4IDIuNSA4LjkgMi41IDEwVjIwQzIuNSAyMS4xIDMuNCAyMiA0LjUgMjJIMTAuNzZDOS45NyAyMC44NyA5LjUgMTkuNDkgOS41IDE4QzkuNSAxNC4xMyAxMi42MyAxMSAxNi41IDExWk03LjQgNkM3LjQgNC4yOSA4Ljc5IDIuOSAxMC41IDIuOUMxMi4yMSAyLjkgMTMuNiA0LjI5IDEzLjYgNlY4SDcuNFY2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE2LjUgMTNDMTMuNzQgMTMgMTEuNSAxNS4yNCAxMS41IDE4QzExLjUgMjAuNzYgMTMuNzQgMjMgMTYuNSAyM0MxOS4yNiAyMyAyMS41IDIwLjc2IDIxLjUgMThDMjEuNSAxNS4yNCAxOS4yNiAxMyAxNi41IDEzWk0xNi41IDE1QzE3LjMzIDE1IDE4IDE1LjY3IDE4IDE2LjVDMTggMTcuMzMgMTcuMzMgMTggMTYuNSAxOEMxNS42NyAxOCAxNSAxNy4zMyAxNSAxNi41QzE1IDE1LjY3IDE1LjY3IDE1IDE2LjUgMTVaTTE2LjUgMjFDMTUuNDcgMjEgMTQuNTYgMjAuNDggMTQuMDIgMTkuNjhDMTQuNzUgMTkuMjYgMTUuNTkgMTkgMTYuNSAxOUMxNy40MSAxOSAxOC4yNSAxOS4yNiAxOC45OCAxOS42OEMxOC40NCAyMC40OCAxNy41MyAyMSAxNi41IDIxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LockPerson = createIcon('LockPerson', [
  [
    'path',
    {
      d: 'M16.5 11C17.2 11 17.87 11.1 18.5 11.29V10C18.5 8.9 17.6 8 16.5 8H15.5V6C15.5 3.24 13.26 1 10.5 1C7.74 1 5.5 3.24 5.5 6V8H4.5C3.4 8 2.5 8.9 2.5 10V20C2.5 21.1 3.4 22 4.5 22H10.76C9.97 20.87 9.5 19.49 9.5 18C9.5 14.13 12.63 11 16.5 11ZM7.4 6C7.4 4.29 8.79 2.9 10.5 2.9C12.21 2.9 13.6 4.29 13.6 6V8H7.4V6Z',
      key: 'x3zpps',
    },
  ],
  [
    'path',
    {
      d: 'M16.5 13C13.74 13 11.5 15.24 11.5 18C11.5 20.76 13.74 23 16.5 23C19.26 23 21.5 20.76 21.5 18C21.5 15.24 19.26 13 16.5 13ZM16.5 15C17.33 15 18 15.67 18 16.5C18 17.33 17.33 18 16.5 18C15.67 18 15 17.33 15 16.5C15 15.67 15.67 15 16.5 15ZM16.5 21C15.47 21 14.56 20.48 14.02 19.68C14.75 19.26 15.59 19 16.5 19C17.41 19 18.25 19.26 18.98 19.68C18.44 20.48 17.53 21 16.5 21Z',
      key: '1ov7ao',
    },
  ],
]);

export default LockPerson;
